// Balises de référencement en double APRÈS le chargement de React (relevé en vrai navigateur du 25/10/2026 : 2
// descriptions, 2 canonicals, 2 og:url, 2 robots sur meteris.fr). Le HTML pré-rendu porte UNE balise de chaque, écrite
// par scripts/prerender-fixup.js et marquée data-prerendu="seo" ; une fois la page montée, react-helmet-async AJOUTE
// les siennes (data-rh) à côté, car il ne remplace que les balises qu'il a lui-même posées. Ce module retire alors la
// balise du pré-rendu — jamais la dernière de son espèce.
//
// La liste des clés est la MÊME que BALISES_UNIQUES de scripts/prerender-fixup.js (test d'égalité dans
// src/data/prerenderFixup.test.js) : une balise marquée là-bas et oubliée ici resterait en double.

export const ATTRIBUT_PRERENDU = 'data-prerendu';

// `cle` est aussi la valeur de l'attribut qui nomme la balise (name, property, rel).
export const BALISES_SEO = [
  ['title', 'title'],
  ['description', 'meta', 'name'],
  ['canonical', 'link', 'rel'],
  ['robots', 'meta', 'name'],
  ['og:type', 'meta', 'property'],
  ['og:site_name', 'meta', 'property'],
  ['og:locale', 'meta', 'property'],
  ['og:title', 'meta', 'property'],
  ['og:description', 'meta', 'property'],
  ['og:url', 'meta', 'property'],
  ['og:image', 'meta', 'property'],
  ['twitter:card', 'meta', 'name'],
  ['twitter:title', 'meta', 'name'],
  ['twitter:description', 'meta', 'name'],
  ['twitter:image', 'meta', 'name'],
].map(([cle, balise, attribut]) => ({ cle, selecteur: attribut ? `${balise}[${attribut}="${cle}"]` : balise }));

// Retire les balises marquées du pré-rendu qui ont une autre balise du même sélecteur dans le <head>.
// Une balise marquée seule reste (la page n'a rien posé à la place) ; une balise non marquée n'est jamais retirée.
export function retirerDoublonsPrerendu(head) {
  if (!head) return 0;
  let retirees = 0;
  BALISES_SEO.forEach(({ selecteur }) => {
    const toutes = Array.prototype.slice.call(head.querySelectorAll(selecteur));
    if (!toutes.some((el) => !el.hasAttribute(ATTRIBUT_PRERENDU))) return;
    toutes.forEach((el) => {
      if (el.hasAttribute(ATTRIBUT_PRERENDU) && el.parentNode) {
        el.parentNode.removeChild(el);
        retirees += 1;
      }
    });
  });
  return retirees;
}

// Retire les doublons tout de suite, puis à chaque balise ajoutée dans le <head> (react-helmet-async ajoute les siennes
// au montage, puis à chaque changement de page). Plus rien de marqué : l'observateur s'arrête.
// À appeler AVANT hydrateRoot / createRoot.
export function surveillerHead(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc || !doc.head) return null;
  const restantes = () => doc.head.querySelector(`[${ATTRIBUT_PRERENDU}]`) !== null;
  retirerDoublonsPrerendu(doc.head);
  if (!restantes() || typeof MutationObserver === 'undefined') return null;
  const observateur = new MutationObserver((mutations) => {
    if (!mutations.some((m) => m.addedNodes && m.addedNodes.length)) return;
    retirerDoublonsPrerendu(doc.head);
    if (!restantes()) observateur.disconnect();
  });
  observateur.observe(doc.head, { childList: true });
  return observateur;
}
